import axios from "axios";
import { getApiBaseUrl } from "../apiBaseUrlFinder";

// Helper function to get auth token
const getAuthToken = () => {
  return localStorage.getItem("token");
};

// Helper function to create auth headers
const getAuthHeaders = () => {
  const token = getAuthToken();
  if (!token) {
    throw new Error("No authentication token found");
  }
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
};

export const preferenceService = {
  // API #1: Get user emails
  // getUserEmails: async () => {
  //   try {
  //     const response = await axios.get(`${getApiBaseUrl()}/get_email`, {
  //       headers: getAuthHeaders(),
  //     });
  //     return response.data;
  //   } catch (error) {
  //     const errorMessage =
  //       error.response?.data?.message ||
  //       error.response?.data?.error ||
  //       "Failed to fetch user emails";
  //     throw new Error(errorMessage);
  //   }
  // },

  // API #2: Update user email
  updateUserEmail: async (existingEmail, newEmail) => {
    try {
      const response = await axios.put(
        `${getApiBaseUrl()}/email_update`,
        {
          existing_email: existingEmail,
          new_email: newEmail,
          email_type: "work_email",
        },
        {
          headers: getAuthHeaders(),
        }
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to update email";
      throw new Error(errorMessage);
    }
  },

  // API #3: Verify updated email
  verifyUpdatedEmail: async (token) => {
    try {
      const response = await axios.put(
        `${getApiBaseUrl()}/verify_updated_email?token=${token}`
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to verify email";
      throw new Error(errorMessage);
    }
  },

  // API #4: Update password (signed in user)
  updatePassword: async (currentPassword, newPassword, retypedNewPassword) => {
    try {
      const response = await axios.put(
        `${getApiBaseUrl()}/signedin_password_update`,
        {
          current_password: currentPassword,
          new_password: newPassword,
          retyped_new_password: retypedNewPassword,
        },
        {
          headers: getAuthHeaders(),
        }
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to update password";
      throw new Error(errorMessage);
    }
  },

  // API #5: Reset password (forgot password)
  resetPassword: async (workEmail) => {
    try {
      const response = await axios.post(`${getApiBaseUrl()}/reset_password`, {
        work_email: workEmail,
      });
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to send password reset";
      throw new Error(errorMessage);
    }
  },
};
